/**
 * Sehr leichter SVG-Sparkline ohne externe Lib.
 * 50-100 Datenpunkte, Inline in KPI-Kacheln.
 */

interface Props {
  data: number[];
  height?: number;
  color?: string;
  fillColor?: string;
  className?: string;
}

export function Sparkline({
  data,
  height = 32,
  color = '#1f97f5',
  fillColor = 'rgba(31,151,245,0.15)',
  className = '',
}: Props) {
  if (data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const w = 100;
  const h = height;
  const points = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return [x, y];
  });
  const pathLine = points.map(([x, y], i) => (i === 0 ? `M ${x},${y}` : `L ${x},${y}`)).join(' ');
  const pathFill = `${pathLine} L ${w},${h} L 0,${h} Z`;

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width="100%"
      height={h}
      preserveAspectRatio="none"
      className={className}
    >
      <path d={pathFill} fill={fillColor} />
      <path d={pathLine} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
